module.exports = __webpack_public_path__ + "static/media/img-hospital-info.0bbec8cc.png";